import { render } from "./home_sidebar.html?vue&type=template&id=2f051a81&external"
import script from "./home_sidebar.js?vue&type=script&lang=js&external"
export * from "./home_sidebar.js?vue&type=script&lang=js&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__